import ReactPaginate from "react-paginate";
import React from "react";

import { IReactPaginationProps } from "./ReactPagination.props";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

const ReactPagination: React.FC<IReactPaginationProps> = ({
  onPageChange,
  pageCount,
  initialPage,
  className,
  hasDivider = true,
}) => {
  const { t } = useTranslation();

  return (
    <ReactPaginate
      pageCount={pageCount}
      initialPage={initialPage}
      pageRangeDisplayed={5}
      className={`flex flex-row items-center justify-end gap-6 w-full ${className} ${
        hasDivider && "border-t border-[#EAECF0] pt-4"
      }`}
      breakClassName="font-[500] text-[12px] leading-[18px] rounded-[8px] p-[12px] lg:text-[14px] lg:leading-[20px] select-none px-4 text-[#667085] cursor-pointer opacity-50"
      breakLabel="..."
      nextLabel={
        <div
          className={`flex flex-row gap-2 items-center select-none cursor-pointer active:opacity-50`}
        >
          <p className="font-[500] text-[14px] leading-[20px] text-[#667085] hidden lg:block">
            {t("next_page")}
          </p>
          <ChevronRight className="text-[#667085] h-[18px] lg:h-[20px]" />
        </div>
      }
      previousLabel={
        <div
          className={`flex flex-row gap-2 items-center select-none cursor-pointer active:opacity-50`}
        >
          <ChevronLeft className="text-[#667085] h-[18px] lg:h-[20px]" />
          <p className="font-[500] text-[14px] leading-[20px] text-[#667085] hidden lg:block">
            {t("prev_page")}
          </p>
        </div>
      }
      pageLinkClassName="font-[500] text-[12px] leading-[18px] lg:text-[14px] lg:leading-[20px] select-none px-2 cursor-pointer active:opacity-50"
      pageClassName="font-[500] text-[12px] leading-[18px] rounded-[8px] lg:text-[14px] lg:leading-[20px] select-none text-[#667085]"
      activeClassName="rounded-[8px] p-[12px] text-primary bg-primary bg-opacity-20 active:opacity-100"
      onPageChange={(val) => onPageChange(val.selected)}
    />
  );
};

ReactPagination.displayName = "ReactPagination";
export default ReactPagination;
